import React, { useMemo } from 'react';

import { ImmutableEntity } from '@uncinc/react-drupal-core/types';

import { DynamicMediaItem, EventCard } from '../../../../components';
import { NodeEvent } from '../../../../types/uncinc_profile/nodes';
import eventDateInfo from '../../../../helpers/eventDateInfo';

interface EventTeaserProps extends React.ComponentPropsWithoutRef<'div'> {
  entity: ImmutableEntity<NodeEvent>;
}

const useEventTeaserDates = ({ field_date }: NodeEvent) => useMemo(() => {
  const { firstUpcomingDate, dates } = eventDateInfo(field_date);
  const hasMultipleDates = dates.length > 1;
  // Fall back to last date if no upcoming dates have been found.
  const teaserDate = firstUpcomingDate || dates[dates.length - 1];

  let startDate;
  let endDate;

  if (teaserDate) {
    startDate = new Date(teaserDate.start.date);
    endDate = new Date(teaserDate.end.date);
  }

  return { startDate, endDate, hasMultipleDates };
}, [field_date]);

const EventTeaser: React.FC<EventTeaserProps> = ({ entity, ...props }) => {
  const event = entity.toJS();
  const title = event.title[0].value;
  const media = event.field_media_item[0];
  const { hasMultipleDates, startDate, endDate } = useEventTeaserDates(event);

  return (
    <EventCard
      {...props}
      startDate={startDate}
      endDate={endDate}
      hasMultipleDates={hasMultipleDates}
      link={event.paths.nl}
      title={title}
      image={media && <DynamicMediaItem media={media} imageAspectRatio="4_3" />}
    />
  );
};

export default EventTeaser;
